/*
*###############################################################################
*Module Name                   : TransactionTAX.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Dinisuru                                     #
*Date                          : Wednesday,January 4th 2023, 10:07:06 pm       #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/



import React, { useState, useEffect, useContext } from 'react';
import { CardText, Col, Row, Alert, Button, Modal, Table, Label } from 'reactstrap'
import ReactPaginate from 'react-paginate';
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import SubdocDownload from "../../../assets/File/SubDocs.xlsx";
import * as XLSX from "xlsx";
import { getSubDocs, GetSupplierTax, GetValidateProductsSubDocs } from './TransactionController';
import DPAlert from 'framework/widgets/DPAlert';
import { CalculateTaxFrom, TaxCalculateFromExcel } from './TransactionTAX';
import { Context } from "app-contexts/CommonContexts"

const TransactionSubDocs = ({ subDocs, setSubDocs, setSubDocApprove, Disable, txn, Location, Transaction, getGridTable,
    setAlertColor, setAlertMsg, setShow, TotalLineAmtCalcualtion, SetTaxtTable, supplierSelect, setProductErrorData, setProductErrorToggle }) => {

    const {
        isHeadOffice, menus, getMenuDetails, endOfDate, txnDecimalAmt, txnDecimalQty, setupLocation
    } = useContext(Context);

    const [isInvalid, setIsInvalid] = useState(false)
    const [valueUpload, setvalueUpload] = useState("")
    const [subDocList, setSubDocList] = useState([])
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [showCancel, setshowCancel] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

    function showFileUpload(e) {
        const file = e.target.files[0];
        readExcel(file);
        setvalueUpload(e.target.value)
    }

    const readExcel = async (file) => {

        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = async (e) => {
            const bufferArray = e.target.result;
            const wb = XLSX.read(bufferArray, { type: "buffer" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);

            if (data.length > 0) {
                let excelItems = []
                data.forEach((item, index) => {
                    excelItems.push({
                        PRO_CODE: item.PRO_CODE,
                        LOC_CODE: item.LOC_CODE,
                        CASEQTY: item.CASEQTY == null || item.CASEQTY == undefined ? parseFloat(0) : txn.intTX_ALLOWMINUS == 1 ? parseFloat(item.CASEQTY ? item.CASEQTY : 0) : Math.abs(parseFloat(item.CASEQTY ? item.CASEQTY : 0)),
                        UNITQTY: item.UNITQTY == null || item.UNITQTY == undefined ? parseFloat(0) :txn.intTX_ALLOWMINUS == 1 ? parseFloat(item.UNITQTY ? item.UNITQTY : 0) : Math.abs(parseFloat(item.UNITQTY ? item.UNITQTY : 0)),
                    })
                });

                let sumByProCode = excelItems.reduce((acc, cur) => {
                    if (!acc[cur.PRO_CODE]) {
                        acc[cur.PRO_CODE] = { PRO_CODE: cur.PRO_CODE, CASEQTY: 0, UNITQTY: 0 };
                    }
                    acc[cur.PRO_CODE].CASEQTY += cur.CASEQTY;
                    acc[cur.PRO_CODE].UNITQTY += cur.UNITQTY;
                    return acc;
                }, {});

                const result = Object.keys(sumByProCode).map((key, index) => {
                    // return { value: key, label: groupedItems[key].join('') };
                    return {
                        'PRO_CODE': sumByProCode[key].PRO_CODE,
                        'CASEQTY': parseFloat(sumByProCode[key].CASEQTY ? sumByProCode[key].CASEQTY : 0),
                        'UNITQTY': parseFloat(sumByProCode[key].UNITQTY ? sumByProCode[key].UNITQTY : 0),
                        'DET_LINENO': parseInt(index + 1),
                    }
                });

                setSubDocList(result)

                if (Location == "") {
                    setAlertColor("danger")
                    setAlertMsg("Please select location")
                    setShow(true)
                    setvalueUpload("")
                    setTimeout(() => {
                        setShow(false)
                    }, 5000);
                    return
                }

                if (txn.intTX_SUPPLIER == 1 && supplierSelect == "") {
                    setAlertColor("danger")
                    setAlertMsg("Please select Supplier")
                    setShow(true)
                    setvalueUpload("")
                    setTimeout(() => {
                        setShow(false)
                    }, 5000);
                    return
                }

                let dataset = await getSubDocs(excelItems) //get validate data from server

                if (dataset.msg == "success") {
                    setSubDocApprove(true)
                    setIsInvalid(false)
                    setvalueUpload("")
                    setsweetAlertShow(true)
                    setAlertDescription("Do you wish to generate the detail section?")
                    setshowCancel(true)
                    setAlertConfirmOption(1)
                } else {
                    setSubDocApprove(false)
                    setIsInvalid(true)
                    setvalueUpload("")
                    setAlertColor("danger")
                    setAlertMsg("Something went wrong!")
                    setShow(true)
                    setTimeout(() => {
                        setShow(false)
                    }, 5000);
                    return
                }
                
                setSubDocs(dataset.subdocsResponse)

            };
        };
    };



    async function GetSubDocsFromProduc() {

        //this function is get products from subdocs and validate products

        var data = {
            transaction: Transaction,
            location: Location,
            supplier: supplierSelect,
            subdocs: subDocList
        }

        var { successDatatable, errorTable, taxDataTable } = await GetValidateProductsSubDocs(data)

        if (errorTable.length > 0) {
            setProductErrorData(errorTable)
            setProductErrorToggle(true)
            return
        }

        if (successDatatable.length == 0) return

        //check if there are values with decimal points where isDecimal is 0 check dcDET_CASEQTY and dcDET_UNITQTY
        var isDecimalItem = successDatatable.filter((item, index) => {
            return item.isDecimal == 0 && (item.dcDET_CASEQTY % 1 != 0 || item.dcDET_UNITQTY % 1 != 0 || item.dcDET_FCASEQTY % 1 != 0 || item.dcDET_FUNITQTY % 1 != 0)
        })

        if (isDecimalItem.length > 0) {
            setshowCancel(false)
            setsweetAlertShow(true)
            setAlertDescription("There were some values with decimal points where isDecimal is 0 and system has rounded them to the nearest whole number")
            setAlertConfirmOption(2)
        }

        var modifiedDetailTable = successDatatable.map((item, index) => {

            item.dcDET_ACOST = parseFloat(item.dcDET_ACOST).toFixed(txnDecimalAmt)
            item.dcDET_APRICE = parseFloat(item.dcDET_APRICE).toFixed(txnDecimalAmt)
            item.dcDET_BALQTY = parseFloat(item.dcDET_BALQTY).toFixed(txnDecimalQty)
            item.dcDET_CASEQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_CASEQTY).toFixed(0) : parseFloat(item.dcDET_CASEQTY).toFixed(txnDecimalQty)
            item.dcDET_CPRICE = parseFloat(item.dcDET_CPRICE).toFixed(txnDecimalAmt)
            item.dcDET_CS = parseFloat(item.dcDET_CS).toFixed(0)
            item.dcDET_DISCPER = parseFloat(item.dcDET_DISCPER).toFixed(txnDecimalAmt)
            item.dcDET_DISCAMT = parseFloat(item.dcDET_DISCAMT).toFixed(txnDecimalAmt)
            item.dcDET_FCASEQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_FCASEQTY).toFixed(0) : parseFloat(item.dcDET_FCASEQTY).toFixed(txnDecimalQty)
            item.dcDET_FUNITQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_FUNITQTY).toFixed(0) : parseFloat(item.dcDET_FUNITQTY).toFixed(txnDecimalQty)
            item.dcDET_OAPRICE = parseFloat(item.dcDET_OAPRICE).toFixed(txnDecimalAmt)
            item.dcDET_OCPRICE = parseFloat(item.dcDET_OCPRICE).toFixed(txnDecimalAmt)
            item.dcDET_OSPRICE = parseFloat(item.dcDET_OSPRICE).toFixed(txnDecimalAmt)
            item.dcDET_SPRICE = parseFloat(item.dcDET_SPRICE).toFixed(txnDecimalAmt)
            item.dcDET_SYSQTY = parseFloat(item.dcDET_SYSQTY).toFixed(txnDecimalQty)
            item.dcDET_UNITQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_UNITQTY).toFixed(0) : parseFloat(item.dcDET_UNITQTY).toFixed(txnDecimalQty)

            return item;
        })

        const dataTable = await TotalLineAmtCalcualtion(modifiedDetailTable)

        //if products are valid then calculate tax and total line amount

        if (txn.intTX_SUPPLIER == 1 && txn.inTX_TAX == 1) {
            if (taxDataTable.length > 0) {
                TaxCalculateFromExcel(SetTaxtTable, dataTable, taxDataTable)
            }
        }
    }


    return (
        <React.Fragment>
            <DPAlert

                confirm_both={sweetAlertShow}
                title={txn.strTX_DESC}
                description={AlertDescription}
                showCancel={showCancel}
                btnColor={"success"}
                cancelColor={"danger"}
                btnYes={showCancel ? "Yes" : "Ok"}
                onConfirm={() => {
                    setsweetAlertShow(false)
                    if (AlertConfirmOption == 1) {
                        GetSubDocsFromProduc()
                    }
                    setshowCancel(true)
                }}
                onCancel={() => {
                    setshowCancel(true)
                    setsweetAlertShow(false)
                }}
            />
            <Row>
                <Col sm={12} md={8} className="mb-4-sm">
                    <TableWithPagination
                        DataTable={subDocs}
                        isInvalid={isInvalid}
                    />
                </Col>
                <Col sm={12} md={2} className="mb-4-sm text-end">
                </Col>
                <Col sm={12} md={1} className="mb-4-sm text-end">
                    <Button
                        color="danger"
                        className="btn-block"
                        size='sm'
                        onClick={() => {
                            setSubDocs([])
                            setSubDocApprove(true)
                            setIsInvalid(false)
                            setvalueUpload("")
                        }}
                        disabled={Disable}
                    >
                        Clear Subdocs
                    </Button>

                </Col>
                <Col sm={12} md={1} className="mb-4-sm text-end">
                    <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                        <li className="import-export-button" style={{ display: "block", opacity: Disable == true ? "0.5" : "1" }}>
                            <input
                                id="StockFile"
                                type="file"
                                onChange={showFileUpload}
                                value={valueUpload}
                                disabled={Disable}
                                accept=".xlsx, .xls, .csv"
                                style={{ display: "none" }}
                            />

                            <label htmlFor="StockFile" title="Master Excel Upload" style={{ cursor: "pointer" }}>
                                <span>
                                    <img className="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px", opacity: Disable == true ? "0.5" : "1" }}></img>
                                </span>
                            </label></li>

                        <li className="import-export-button" style={{ display: "block", paddingLeft: '10px' }}>
                            <a href={SubdocDownload} download="Subdoc file download" data-tip title="Subdoc excel template download"
                                style={{ pointerEvents: Disable ? 'none' : '', }}
                            >
                                <img className="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: Disable == true ? "0.5" : "1" }}></img>
                            </a></li>
                    </ul>
                </Col>
            </Row>

        </React.Fragment>
    );

}





export default TransactionSubDocs;



const TableWithPagination = ({ DataTable, handleSwitchChanges, change, disabled, isInvalid }) => {


    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(20)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataTable.slice(indexOfFirstPost, indexOfLastPost)


    useEffect(() => {
        setCurrentPage(1)
    }, [change])

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };


    return (
        <React.Fragment>
            <Row className='mt-3 mb-3'>
                <Col sm={12} md={2} className="mb-12-sm w"  >
                    <Label>Product</Label>
                </Col>
                <Col sm={12} md={5} className="mb-12-sm w"  >
                    <Label>Description</Label>
                </Col>
                <Col sm={12} md={1} className="mb-12-sm w"  >
                    <Label>Location</Label>
                </Col>
                <Col sm={12} md={2} className="mb-12-sm w"  >
                    <Label>Description</Label>
                </Col>
                <Col sm={12} md={1} className="mb-12-sm w"  >
                    <Label>CASEQTY</Label>
                </Col>
                <Col sm={12} md={1} className="mb-12-sm w"  >
                    <Label>UNITQTY</Label>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    {currentPosts.map((values, index) => {
                        return (
                            <Row key={values.id} style={{ background: isInvalid ? 'rgb(237 198 198)' : '' }}>
                                <Col sm={12} md={2}>
                                    <Label>{values.prO_CODE}</Label>
                                </Col>
                                <Col sm={12} md={5}>
                                    <Label>{values.prO_DESC}</Label>
                                </Col>
                                <Col sm={12} md={1}>
                                    <Label>{values.loC_CODE}</Label>
                                </Col>
                                <Col sm={12} md={2}>
                                    <Label>{values.loC_DESC}</Label>
                                </Col>
                                <Col sm={12} md={1}>
                                    <Label>{values.caseqty}</Label>
                                </Col>
                                <Col sm={12} md={1}>
                                    <Label>{values.unitqty}</Label>
                                </Col>
                            </Row>
                        )
                    })
                    }
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(DataTable.length / postsPerPage)}
                        pageRangeDisplayed={1}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-left pagination-sm'}
                    />
                </Col>
            </Row>

        </React.Fragment>
    )
}